export enum NotificationSettingsEnabled {
  ON = 'ON',
  OFF = 'OFF',
}
